'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(o, e) {
    if (null == o) return {};
    var r, t, n = _object_without_properties_loose(o, e);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(o);
        for(t = 0; t < p.length; t++)r = p[t], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(o, r) && (n[r] = o[r]);
    }
    return n;
}
function _object_without_properties_loose(o, e) {
    if (null == o) return {};
    var r, t, n = {}, p = Object.keys(o);
    for(t = 0; t < p.length; t++)r = p[t], e.indexOf(r) >= 0 || (n[r] = o[r]);
    return n;
}
const ComboboxPopoverTitle = renderWithRef('ComboboxPopoverTitle', null, (r, t)=>{
    var { children: n } = r;
    return jsx(RenderComp, {
        root: "h4",
        classNames: [
            'swan-combobox-popover-title'
        ],
        forwardedRef: t,
        props: _object_without_properties(r, [
            "children"
        ]),
        children: n
    });
});

export { ComboboxPopoverTitle };
